import styled from 'styled-components';

export const KeyBenefitsSection = styled.div`
  padding: 50px 0;
  margin-top: 50px;
  background-color: #f7f7f7;

  &#benefits_4 {
    margin-top: 0px;
    border-top: 1px solid #fff;
    h2 {
      color: #000;
    }
  }

  &#benefits_3 {
    .benefits_caption {
      h2 {
        @media (max-width: 767.98px) {
          margin-bottom: 3rem;
        }
      }
    }

    @media (max-width: 767.98px) {
      margin-top: 30px;
    }
  }
`;

export const SectionCaption = styled.div`
  position: relative;
  text-align: center;

  h2 {
    color: #4a4a4a;
    margin-bottom: 3rem;

    @media (max-width: 767.98px) {
      font-size: 20px;
      line-height: 30px;
      margin-bottom: 1rem;
    }
  }

  &.benefits_caption {
    h2 {
      margin-bottom: 3rem;

      @media (max-width: 767.98px) {
        font-size: 20px;
        line-height: 30px;
        margin-bottom: 1rem;
      }
    }
  }
`;

export const KeyContent = styled.div`
  position: relative;
  z-index: 2;
`;

export const KeyColumn = styled.ul`
  margin: 0;
  padding: 0;
  list-style-type: none;
  display: grid;
  grid-template-columns: 50% 50%;

  @media (max-width: 767.98px) {
    grid-template-columns: 100%;
  }
`;

export const LiKey = styled.li`
  display: flex;
  margin-bottom: 1.5rem;
  min-height: 33px;
  align-items: center;
  position: relative;

  &[dir='ltr'] {
    // padding-right: 30px;
    padding-left: 80px;
  }

  &[dir='rtl'] {
    // padding-left: 30px;
    padding-right: 47px;
  }

  @media (max-width: 991.98px) {
    &:last-child {
      margin-bottom: 0;
    }
  }

  span {
    color: #898989;

    &:first-child {
      position: absolute;
      top: 0;

      &[dir='ltr'] {
        left: 0;
      }

      &[dir='rtl'] {
        right: 0;
      }
    }
  }

  svg {
    width: 33px;
    height: 32px;
  }
`;
